import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
export default function Facebook(props) {
  return (
    <SvgIcon title="Facebook" height="24" width="24" {...props}>
      <path d="M22 12C22 6.47717 17.5229 2.00002 12 2.00002C6.47715 2.00002 2 6.47717 2 12C2 16.9913 5.65686 21.1283 10.4375 21.8785V14.8906H7.89844V12H10.4375V9.7969C10.4375 7.29065 11.9304 5.90627 14.2146 5.90627C15.3087 5.90627 16.4531 6.10159 16.4531 6.10159V8.56252H15.1921C13.9499 8.56252 13.5625 9.33336 13.5625 10.1242V12H16.3359L15.8926 14.8906H13.5625V21.8785C18.3431 21.1283 22 16.9913 22 12Z" />
    </SvgIcon>
  );
}
